// Route chunk loaders that more than one place needs.
//
// The map route pulls leaflet + react-leaflet with it, so the first tap on a link to
// /location otherwise waits on a chunk download with nothing on screen. Importing the
// chunk on hover/touch starts that download while the finger is still travelling, and a
// second call is free — the module registry caches the promise.
export const loadJobsByLocation = () => import("../page/JobsByLocation");

export const preloadJobsByLocation = () => { loadJobsByLocation(); };
